import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import ServicePage from '../components/ServicePage';
import services from '../data/services';

const ServiceDetail = () => {
  const { slug } = useParams();
  const service = services[slug];

  if (!service) return <Navigate to="/services" replace />;

  return <ServicePage service={service} />;
};

export default ServiceDetail;
